import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  NotificationRequest,
  NotificationResponse,
  UserNotificationResponse,
} from '@entities/notification';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private api: ApiService) {}
  /**
   * 報告書メッセージ一覧(システム管理者専用)を取得する
   * @returns 報告書メッセージ一覧
   */
  findList(
    historyFrom: Date,
    historyTo: Date | null,
  ): Observable<NotificationResponse[]> {
    const url = '/notification-details';
    // クエリストリングを追加
    let params = new HttpParams();

    const historyFromParam: string = historyFrom.toISOString();

    let historyToParam: string = '';
    if (historyTo instanceof Date) {
      historyToParam = historyTo.toISOString();
    }

    params = params.set('history_from', historyFromParam);
    params = params.set('history_to', historyToParam);
    return this.api.get<NotificationResponse[]>(url, { params });
  }

  /**
   * 報告書メッセージ一覧(一般ユーザー用)を取得する
   * @returns 報告書メッセージ一覧(一般ユーザー用)
   */
  findListForUser(historyTo: Date): Observable<UserNotificationResponse> {
    const url = `/notifications`;
    // クエリストリングを追加
    let params = new HttpParams();
    const historyToParam: string = historyTo.toISOString();

    params = params.set('history_to', historyToParam);
    return this.api.get<UserNotificationResponse>(url, { params });
  }

  /**
   * 報告書メッセージを追加する
   * @param request 追加内容
   */
  add(request: NotificationRequest): Observable<NotificationResponse> {
    const url = '/notifications';
    return this.api.post<NotificationResponse>(url, request);
  }

  /**
   * 報告書メッセージを更新する
   * @param request 更新内容
   */
  update(request: NotificationRequest): Observable<NotificationResponse> {
    const url = `/notifications/${request.messageId}`;
    return this.api.put<NotificationResponse>(url, request);
  }

  /**
   * 報告書メッセージを削除する
   * @param messageId 報告書メッセージID
   */
  delete(messageId: string): Observable<void> {
    const url = `/notifications/${messageId}`;
    return this.api.delete<void>(url);
  }

  /**
   * 報告書メッセージを既読にする
   * @param messageId 報告書メッセージID
   */
  markAsRead(): Observable<void> {
    const url = `/notifications/_mark_as_read`;
    return this.api.post<void>(url, {});
  }
}
